import React from 'react';
import { render } from 'react-dom';
import Bingo from './Bingo';
import './App.css';

render(<Bingo />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js